import MultipleTnC from './MultipleTnC'
export default MultipleTnC
